import React, { useEffect, useState } from "react";
import { KendoEditor } from "../../Kendo/kendo_editor";
import { Button, ErrorMsg, sessionUser } from "../../Util/common";
import { corefetch, corepost } from "../../Util/axios_core_helper";
import { baseURL } from "../../Util/axios_helper";

export const TermsandCondition = () => {
  const [privacyAndTerms, setPrivacyAndTerms] = useState({
    patid: 0,
    description: "",
    SavedBy: sessionUser(),
    CategoryType: "TERMS",
  });
  const [privacyPolErr, setPrivacyPolErr] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    // Trim the description to check for empty spaces or non-content
    const sanitizedDescription = privacyAndTerms.description
      .replace(/<\/?[^>]+(>|$)/g, "") // Strip HTML tags
      .replace(/&nbsp;/g, " ") // Replace non-breaking spaces with regular spaces
      .trim(); // Remove leading/trailing spaces

    if (!sanitizedDescription) {
      setPrivacyPolErr(true); // Show error if description is empty or contains only whitespace
      return;
    }

    console.log(privacyAndTerms);
    try {
      await corepost("PoliciesandTerms/InsertUpdatePT", privacyAndTerms);
      setrefreshflag((prev) => prev + 1);

      setPrivacyPolErr(false); // Reset error flag on successful submission
    } catch (error) {
      console.error("Error updating data", error);
    }
  };

  const handleEditorChange = (e) => {
    const newValue = e;

    // Strip HTML tags and extra spaces
    const strippedValue = newValue
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

    const isEmpty = /^[\s\n]*$/.test(strippedValue);

    // Update state for the editor content
    setPrivacyAndTerms((prevState) => ({
      ...prevState,
      description: newValue,
    }));

    // Set the error flag based on whether the value is empty
    setPrivacyPolErr(isEmpty);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch(
          "PoliciesandTerms/GetPoliciesAndTerms?CategoryType=TERMS"
        );
        if (response && response.length > 0) {
          setPrivacyAndTerms(response[0]);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="card bg-white">
      <div className="card-body">
        <div>
          <div className="form-group">
            <KendoEditor
              name="description"
              imageBrowser={{
                enable: true,
                read: baseURL + "EmailTemplate/GetImages",
                upload: baseURL + "EmailTemplate/UploadImage",
                delete: baseURL + "EmailTemplate/DeleteImage",
                image: baseURL + "EmailTemplate/GetImage?path={0}",
                thumbnail: baseURL + "EmailTemplate/GetThumbnail",
              }}
              value={privacyAndTerms.description}
              required={true}
              onChange={handleEditorChange}
              insertImage={false}
              createLink={false}
              unlink={false}
            />
          </div>
          {privacyPolErr && (
            <ErrorMsg text="Terms and Conditions is required" />
          )}
          <div className="d-flex justify-content-end mt-2">
            <Button name="Save" onClick={onSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
};
